import { Box, Typography } from 'src/components/PulseUI';
import { faCircle, faExternalLinkAlt } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';

const EducationItem = ({ item }) => {
  return (
    <Box className="w-full flex flex-col pb-4 last:pb-0">
      <Typography variant="body2" className="text-tertiary font-normal">
        {item.education_type}
      </Typography>
      <Typography variant="body2" className="text-primary font-medium">
        {item.freida_program_url ? (
          <a
            href={item.freida_program_url}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="freida-program-link"
            className="text-sky-900"
            onClick={(clickEvent) => clickEvent.stopPropagation()}
          >
            {item.name}
            <Icon icon={faExternalLinkAlt} size="sm" className="ml-1" />
          </a>
        ) : (
          item.name
        )}
      </Typography>
      <Typography variant="body2" className="text-tertiary font-normal">
        {item.graduation_year}
        {item.focus && (
          <>
            <Icon
              icon={faCircle}
              className="text-neutral-300 !h-[0.375rem] !w-[0.375rem] !px-2 pb-1"
            />
          </>
        )}
        {item.focus}
      </Typography>
    </Box>
  );
};

export default EducationItem;
